import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { tPaymentService } from 'src/app/services/tPayment.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPaymentModel } from 'src/app/models/tPaymentModel';
import { tBillPayModel, BillPay_ItemType } from 'src/app/models/tBillPayModel';
import { AppCurrencyPipe } from 'src/app/services/CommonService/custom.currency.pipe';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { HTTP_ResultModel } from 'src/app/models/non-master-model/HTTP_ResultModel';
import { SpecialPaymentMethod } from 'src/app/models/non-master-model/SpecialPaymentMethod';
import { BillPayPaymentMethod_ehCardDialogService } from 'src/app/services/Non-Master/BillPayPaymentMethod_ehCardDialog.service';
import { ToFixRange } from 'src/app/models/non-master-model/ToFixRange';
import { BillPayPayment_Package_totalAmountService } from 'src/app/services/Non-Master/BillPayPayment_Package_totalAmount.service';

import { decimalplaceHandler } from 'src/app/services/Non-Master/decimalplaceHandler.service';


@Component({
  selector: 'app-bill-payment-walkin-dialog',
  templateUrl: './bill-payment-walkin-dialog.component.html',
  styleUrls: ['./bill-payment-walkin-dialog.component.css']
})
export class BillPaymentWalkinDialogComponent implements OnInit {


  TAG = "BillPaymentWalkinDialogComponent";
  // dataList_item: tBillPayModel[];
  // dataList_Payment: tBillPayModel[];
  @Input() invoiceID: string;
  @Input() dataList_Item: tBillPayModel[];
  @Input() dataList_Payment: tBillPayModel[];

  editForm: FormGroup;
  submitted = false;
  paymentMethodList: tPaymentModel[] = new Array;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private apiResultHandlerService: ApiResultHandlerService,
    private tPaymentService: tPaymentService,
    private tBillPayService: tBillPayService,
    private billPayPaymentMethod_ehCardDialogService: BillPayPaymentMethod_ehCardDialogService,
    private billPayPayment_Package_totalAmountService: BillPayPayment_Package_totalAmountService,
    private decimalplaceHandler: decimalplaceHandler

  ) { }

  //UI
  arAmount: number;
  billRemaining: number;

  ngOnInit() {
    this.editForm = this.formBuilder.group({

      bpArAmount: [],
      paymentWay: [this.paymentMethodList],
      payAmount: [],
      billRemaining: [this.billRemaining],
      bpRemark: []

    });

    this.getAllData();
  }

  getAllData(): void {
    //   this.log.i(this.TAG, 'getAllData ');
    // this.getItemTypeInfo();

    // this.dataList_item = new Array;
    // this.dataList_Payment = new Array;
    // for (var i = 0; i < data.length; i++) {
    //   if (data[i].bpPaymentNumber == null) {

    //     this.dataList_item.push(data[i]);
    //   } else {
    //     this.dataList_Payment.push(data[i]);
    //   }
    // }
    this.UpdateDialogValue();



    this.getPaymentMethod();
  }

  UpdateDialogValue() {
    this.arAmount = 0;
    // this.log.i(this.TAG, "starting arAmount = " + this.arAmount);

    for (var i = 0; i < this.dataList_Item.length; i++) {
      // this.log.i(this.TAG, "last arAmount = " + this.arAmount);
      this.arAmount += Number.parseFloat(this.dataList_Item[i].bpArAmount.toString());


    }

    for (var p = 0; p < this.dataList_Payment.length; p++) {
      this.arAmount += Number.parseFloat(this.dataList_Payment[p].bpArAmount.toString());

    }

    // this.log.i(this.TAG, "UpdateDialogValue arAmount = " + this.arAmount);

    (<FormControl>this.editForm.controls['bpArAmount']).setValue(this.displayTotalAmt(this.arAmount));
    // (<FormControl>this.editForm.controls['bpArAmount']).setValue(this.arAmount.toFixed(ToFixRange.BillingPayment));
  }

  getPaymentMethod() {
    this.log.i(this.TAG, "do getPaymentMethod");
    var shopID = NavigationComponent.selectedShopID.toString();

    this.tPaymentService.getActiveData(shopID).subscribe(data => {
      this.paymentMethodList = data;
    });
  }

  changePayAmount(inputValue: number) {
    this.log.d(this.TAG, "do changePayAmount inputValue = " + inputValue + " , new value = " + (this.arAmount - inputValue));
    // this.UpdateDialogValue();


    (<FormControl>this.editForm.controls['billRemaining']).setValue(this.displayTotalAmt(this.arAmount - inputValue));
    // (<FormControl>this.editForm.controls['billRemaining']).setValue((this.arAmount - inputValue).toFixed(ToFixRange.BillingPayment));
  }


  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }


  get f() { return this.editForm.controls; }

  confirm() {
    // this.activeModal.dismiss();
    this.log.i(this.TAG, "do confirm");




  }

  submitWalkInData() {
    this.log.i(this.TAG, "do submitWalkInData");

    var allData: tBillPayModel[] = new Array;
    for (var pp = 0; pp < this.dataList_Item.length; pp++) {
      allData.push(this.dataList_Item[pp]);
    }

    for (var pp = 0; pp < this.dataList_Payment.length; pp++) {
      allData.push(this.dataList_Payment[pp]);
    }


    this.tBillPayService.addWalkInMultiData(allData).subscribe(

      (data: any) => {
        this.log.i(this.TAG, "do submitItemFirst data = " + JSON.stringify(data));

        if (data.isSuccess == true && data.statusCode == StatusMessage.Status_OK) {
          this.log.i(this.TAG, JSON.stringify(data.data));

          // this.dataList_Item = new Array;
          // var dataList = data.data;
          // for (var i = 0; i < dataList.length; i++) {
          //   var itemType = dataList[i].bpItemType;
          //   if (itemType == BillPay_ItemType.ITEM || itemType == BillPay_ItemType.ITEM_PACKAGE) {
          //     this.dataList_Item.push(dataList[i]);
          //   }
          // }
          this.log.i(this.TAG, "new length = " + this.dataList_Item.length);
          this.submitData(null);
        }


      },
      err => {
        this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));

        this.apiResultHandlerService.ErrHandler();

      });

  }

  selectPackage_ReductTotalAmount() {
    this.log.i(this.TAG, "do selectPackage_ReductTotalAmount");

    this.billPayPayment_Package_totalAmountService.openDialog(this.dataList_Item[0].bpPatientID, this.dataList_Item[0].bpInvoiceNumber,null).result.then(
      (result) => {

        // var ehCardConfirmedVoucher = JSON.parse(result).ehCardConfirmedID;
        // this.log.i(this.TAG, "ehCardDialog voucherID = " + ehCardConfirmedVoucher);
        // this.submitData(ehCardConfirmedVoucher);
        this.activeModal.close(result);

      }, (reason) => {
        this.log.i(this.TAG, "ehCardDialog cancel reason = " + reason);

      });

  }

  displayTotalAmt(amt: number) {
    return this.decimalplaceHandler.convertToValueStr(amt, decimalplaceHandler.dpTotalAmt, decimalplaceHandler.round_TotalAmt);
  }


  submitData(ehCardVoucher: string) {
    this.submitted = true;

    
    if (this.editForm.valid) {

      var shopID: string = NavigationComponent.selectedShopID.toString();
      var bpInvoiceNumber: string = this.dataList_Item[0].bpInvoiceNumber;
      var bpLineNumber: number = 1;
      var bpPaymentNumber: string = this.editForm.get('paymentWay').value;
      var bpDateTime: Date = null;
      var bpPatientID: string = this.dataList_Item[0].bpPatientID;
      var bpChangeID: string = this.dataList_Item[0].bpChangeID;
      var bpConsultNumber: string = null;
      var bpItemID: string = null;
      var bpItemType: string = BillPay_ItemType.PAYMENT;
      var bpItemDesc: string = null;
      var bpQty: number = null;
      var bpStandardPrice: number = null;

      var bpFinalPrice: number = null;
      var bpLineAmount: number = null;

      var bpArAmount: number = this.editForm.get('payAmount').value;
      var bpPackInvoiceNo: string = null;
      var bpPackItemID: string = null;
      var bpPackageQty: number = null;
      var bpPackFaceAmt: number = null;
      var bpEmployeeID: string = null;
      var bpPrintName: string = null;
      var bpPaymentMethodID: string = this.editForm.get('paymentWay').value;

      var paymentName: string = null;
      for (var i = 0; i < this.paymentMethodList.length; i++) {
        if (bpPaymentMethodID == this.paymentMethodList[i].paymentID) {
          paymentName = this.paymentMethodList[i].paymentName;
        }
      }

      var bpPaymentMethodName: string = paymentName;
      var bpRemark: string = null;
      var bpPaymentRemark: string = this.editForm.get('bpRemark').value;

      var inActive: string = "N";
      var lastModifyDatetime: Date = null;
      var lastModifyUserID: string = NavigationComponent.userID;


      var newBillPay = new tBillPayModel();
      newBillPay.shopID = shopID;
      newBillPay.bpInvoiceNumber = bpInvoiceNumber;
      newBillPay.bpLineNumber = bpLineNumber;
      newBillPay.bpPaymentNumber = bpPaymentNumber;
      newBillPay.bpDateTime = bpDateTime;
      newBillPay.bpPatientID = bpPatientID;
      newBillPay.bpChangeID = bpChangeID;
      newBillPay.bpConsultNumber = bpConsultNumber;
      newBillPay.bpItemID = bpItemID;
      newBillPay.bpItemType = bpItemType;
      newBillPay.bpItemDesc = bpItemDesc;
      newBillPay.bpQty = bpQty;
      newBillPay.bpStandardPrice = bpStandardPrice;
      newBillPay.bpFinalPrice = bpFinalPrice;
      newBillPay.bpLineAmount = bpLineAmount;
      newBillPay.bpArAmount = bpArAmount * -1;
      newBillPay.bpPackInvoiceNo = bpPackInvoiceNo;
      newBillPay.bpPackItemID = bpPackItemID;
      newBillPay.bpPackageQty = bpPackageQty;
      newBillPay.bpPackFaceAmt = bpPackFaceAmt;
      newBillPay.bpEmployeeID = bpEmployeeID;
      newBillPay.bpPrintName = bpPrintName;
      newBillPay.bpPaymentMethodID = bpPaymentMethodID;
      newBillPay.bpPaymentMethodName = bpPaymentMethodName;
      newBillPay.bpRemark = bpRemark;
      newBillPay.bpPaymentRemark = bpPaymentRemark;
      newBillPay.inActive = inActive;
      newBillPay.ehVoucher = ehCardVoucher;
      newBillPay.lastModifyDatetime = lastModifyDatetime;
      newBillPay.lastModifyUserID = lastModifyUserID;


      // var paymentList: tBillPayModel[] = new Array;
      // paymentList.push(newBillPay);

      this.log.i(this.TAG, "paymentList newBillPay = " + JSON.stringify(newBillPay));


      //count arAmount & pay amount
      var totalItemAmount = 0;
      var totoalPayAmount = 0;
      for (var i = 0; i < this.dataList_Item.length; i++) {
        // this.log.i(this.TAG, "last arAmount = " + this.arAmount);
        totalItemAmount += Number.parseFloat(this.dataList_Item[i].bpArAmount.toString());


      }

      for (var p = 0; p < this.dataList_Payment.length; p++) {
        totoalPayAmount += Number.parseFloat(this.dataList_Payment[p].bpArAmount.toString());

      }

      this.log.i(this.TAG,"totalItemAmount = "+totalItemAmount+" , totoalPayAmount = "+totoalPayAmount);
      
      if (totoalPayAmount - totalItemAmount >= 0) {

        this.submitWalkInData();


      } else {

        //still have unpay 
        //this.activeModal.close(newBillPay);
        this.dataList_Payment.push(newBillPay);
        this.UpdateDialogValue();
        (<FormControl>this.editForm.controls['payAmount']).setValue('');
        
      }

    }
  }


}
